import React from 'react';

import icon from 'assets/images/softwares/CompletionDesign1.png';

const Icon = ({ width }) => <img src={icon} alt="Completion Design" width={width || '25'} />;

export default Icon;
